const baseAdPlacementConfig = {
  desktopAdFrequency: 7,
  firstAdPlacement: 3,
  mobileAdFrequency: 5,
  showBetweenLatestsAndPopular: false,
  showEndArticleAd: false,
  showLeaderboardAd: true,
};
interface AdPlacementConfigProps {
  desktopAdFrequency: number;
  mobileAdFrequency: number;
  firstAdPlacement: number;
  showBetweenLatestsAndPopular: boolean;
  showEndArticleAd: boolean;
  showLeaderboardAd: boolean;
}

const getAdPlacementConfig = (variantInfo: AdPlacementConfigProps | null) => variantInfo || baseAdPlacementConfig;
export default getAdPlacementConfig;
export type { AdPlacementConfigProps };
